import { APIService } from 'connectors/api/rest';

export const Brands = {
  async getList(params) {
    try {
      return await APIService.GET('brands', params);
    } catch (e) {
      return null;
    }
  },
};
